import React from "react";

const IFile = ({
  color = "#3268AE",
  width = "12",
  height = "12",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M8.20459 3.625C8.26866 3.625 8.38534 3.62006 8.49951 3.65332L8.54834 3.66992L8.62012 3.7041C8.66642 3.72995 8.70924 3.76168 8.74756 3.79834L8.80127 3.85693L8.83154 3.89844C8.89686 3.99769 8.92647 4.11059 8.94531 4.17188L10.6992 9.87207C10.7241 9.95301 10.7507 10.0376 10.7661 10.1104C10.782 10.1853 10.7971 10.2932 10.7651 10.4121C10.7243 10.5643 10.6275 10.6955 10.4941 10.7793C10.3899 10.8448 10.2819 10.8618 10.2056 10.8687C10.1315 10.8753 10.0431 10.875 9.9585 10.875H3.79541C3.72218 10.875 3.58003 10.8816 3.45166 10.8301C3.35278 10.7904 3.26574 10.7259 3.19873 10.6431C3.11181 10.5356 3.07622 10.3982 3.05469 10.3281L1.30078 4.62793C1.27587 4.54699 1.24934 4.46243 1.23389 4.38965C1.21798 4.31471 1.20294 4.2068 1.23486 4.08789L1.25293 4.03174C1.30067 3.90364 1.3892 3.79402 1.50586 3.7207L1.58447 3.68018C1.66227 3.64743 1.73722 3.63647 1.79443 3.63135C1.86848 3.62474 1.95692 3.625 2.0415 3.625H8.20459ZM2.00781 4.375C2.01093 4.38516 2.01409 4.3959 2.01758 4.40723L3.77148 10.1074C3.77334 10.1135 3.77519 10.1191 3.77685 10.1245C3.78268 10.1245 3.78885 10.125 3.79541 10.125H9.9585C9.97017 10.125 9.98121 10.1245 9.9917 10.1245C9.98864 10.1145 9.98584 10.1039 9.98242 10.0928L8.22852 4.39258C8.22659 4.38632 8.22437 4.38056 8.22266 4.375H2.00781Z"
        fill={color}
      />
      <path
        d="M1.65927 4.51763C1.60534 4.34235 1.57837 4.25471 1.59704 4.18518C1.61339 4.12429 1.65214 4.07182 1.70552 4.03829C1.76649 4 1.85819 4 2.04158 4H8.20457C8.31062 4 8.36365 4 8.40848 4.01799C8.44805 4.03387 8.4829 4.05961 8.50972 4.09277C8.54009 4.13032 8.55569 4.181 8.58688 4.28237L10.3407 9.98237C10.3947 10.1576 10.4216 10.2453 10.403 10.3148C10.3866 10.3757 10.3479 10.4282 10.2945 10.4617C10.2335 10.5 10.1418 10.5 9.95841 10.5H3.79543C3.68937 10.5 3.63634 10.5 3.59152 10.482C3.55195 10.4661 3.5171 10.4404 3.49028 10.4072C3.4599 10.3697 3.44431 10.319 3.41312 10.2176L1.65927 4.51763Z"
        fill={color}
      />
      <path
        d="M7.375 2.125H10.25C10.5952 2.125 10.875 2.40482 10.875 2.75V10.25C10.875 10.5952 10.5952 10.875 10.25 10.875H9.5V10.125H10.125V2.875H7.25C6.90482 2.875 6.625 2.59518 6.625 2.25V1.875H4.875V2.25C4.875 2.59518 4.59518 2.875 4.25 2.875H3.375V4H2.625V2.75C2.625 2.40482 2.90482 2.125 3.25 2.125H4.125V1.75C4.125 1.40482 4.40482 1.125 4.75 1.125H6.75C7.09518 1.125 7.375 1.40482 7.375 1.75V2.125Z"
        fill={color}
      />
    </svg>
  );
};

export default IFile;
